import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Main from "./main/index";
import Maintenance from './Maintenance/index'
import FcModule from './FC/index'
import FisModule from './FIS/index'
import CXC from './CXC/index'
import CXP from './CXP'
import FAC from './FAC'
import BANK from './Bank'
import UC from './UC'
import customViews from './customViews'
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import AssetsModule from "./Assets";
import PointOfSale from "./PointOfSale"
import { DeviceIP } from "../util/DaFrameword";
import { GetDeviceIP } from "../appRedux/actions";

const App = ({ match }) => {

  const dispatch = useDispatch()
  const location = useLocation();
  const history = useHistory()
  const navBarItems = useSelector(({ settings }) => settings.NavBarItems);

  const fetchIP = async () => {
    try {
      const ip = await DeviceIP()
      dispatch(GetDeviceIP(ip))
    } catch (error) {
      console.error('Failed to fetch IP:', error);
    }
  };

  useEffect(() => {
    const search = location.search;
    const InterfaceId = new URLSearchParams(search).get("I");
    const ModuleId = new URLSearchParams(search).get("M");
    const TabId = new URLSearchParams(search).get("T");
    const pathname = location.pathname.replace(`?I=${InterfaceId}&T=${TabId}&M=${ModuleId}`, "");
    //This is to get the PC IP
    fetchIP()
    //Validar que la ruta a la que se intenta acceder este dentro de las rutas del usuario, esto para evitar que el usuario pueda acceder a rutas escribiendo la URL
    //if (search.trim() !== "" && navBarItems.length > 0) {
    const interfaces = flattenModules(navBarItems ?? []);
    const hasAccess = interfaces.some(i => i.url.trim() === pathname.trim());
    const allowedurls = ["/", "/EP/ErrorPages/error-401", "/EP/ErrorPages/error-404", "/EP/ErrorPages/error-500", "/Maintenance/Main"]
    if (hasAccess
      || allowedurls.includes(pathname)
      || pathname.includes("/main/dashboard/crypto")
      || pathname.includes("/Maintenance")
      || pathname.includes("/UC/Entry/CompanyCreate")
      || navBarItems == null
      || pathname.includes("/PointOfSale/Entry/PointOfSale02")
    ) {
      console.log("Tiene acceso a la ruta")
    } else {
      console.log("No tiene acceso a la ruta, redirigiendo a error 401")
      history.push(`${match.url}EP/ErrorPages/error-401`);
    }
  }, [location, navBarItems])

  const flattenModules = (data) => {
    return data.flatMap(module =>
      module.imrTabsInterfaces.flatMap(tab =>
        tab.moduleInterfaces.map((iface, ifaceIndex) => {
          const isFirstInterface = ifaceIndex === 0;

          return {
            // Módulo solo en la primera fila de cada tab
            moduleId: isFirstInterface ? module.moduleId : "",
            moduleDisplay: isFirstInterface ? module.moduleDisplay : "",
            abreviation: isFirstInterface ? module.abreviation : "",

            // Tab solo en la primera fila del tab
            tabId: isFirstInterface ? tab.tabId : "",
            tabsDisplay: isFirstInterface ? tab.tabsDisplay : "",

            // Interfaz siempre
            interfaceId: iface.id,
            displayInterface: iface.displayInterface,
            url: iface.url,
            interfaceOrder: iface.interfaceOrder,
            interfaceType: iface.interfaceType,
            accessId: iface.accessId,
            hasAccess: iface.hasAccess,
            generateDocument: iface.generateDocument,
            active: iface.active,
            selected: false
          };
        })
      )
    );
  }




  return <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}main`} component={Main} />
      <Route path={`${match.url}FC`} component={FcModule} />
      <Route path={`${match.url}FIS`} component={FisModule} />
      <Route path={`${match.url}CXC`} component={CXC} />
      <Route path={`${match.url}CXP`} component={CXP} />
      <Route path={`${match.url}FAC`} component={FAC} />
      <Route path={`${match.url}Maintenance`} component={Maintenance} />
      <Route path={`${match.url}Bank`} component={BANK} />
      <Route path={`${match.url}UC`} component={UC} />
      <Route path={`${match.url}EP`} component={customViews} />
      <Route path={`${match.url}Assets`} component={AssetsModule} />
      <Route path={`${match.url}PointOfSale`} component={PointOfSale}></Route>
    </Switch>

  </div>
};
export default App;
